/* ARGOING Desert Storm REV15b — selettore varianti generico (1-3 opzioni) collegato a prezzo, codice, tabella, galleria e carrello */
(function () {
  var D = window.AG_DATI || { v: [], o: [] };
  var V = D.v || [], O = D.o || [];
  function eur(n) { if (Math.round(n * 100) % 100) return eur2(n); return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €'; }
  function eur2(n) { var s = (Math.round(n * 100) / 100).toFixed(2).split('.'); return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1] + ' €'; }

  /* ---------- galleria ---------- */
  var g = document.querySelector('[data-agg]');
  var track = g && g.querySelector('[data-track]');
  var thumbs = g ? [].slice.call(g.querySelectorAll('[data-thumbs] button')) : [];
  var n = g && g.querySelector('[data-n]');
  var cur = 0;
  function segna() {
    thumbs.forEach(function (b, k) { b.classList.toggle('is-on', k === cur); });
    if (n) n.textContent = (cur + 1) + ' / ' + thumbs.length;
    var b = thumbs[cur];
    if (b) { var p = b.parentNode; p.scrollTo({ left: b.offsetLeft - p.clientWidth / 2 + b.clientWidth / 2, behavior: 'smooth' }); }
  }
  function vai(i, smooth) {
    if (!track || !thumbs.length) return;
    var tot = thumbs.length; cur = (i + tot) % tot;
    track.scrollTo({ left: track.clientWidth * cur, behavior: smooth === false ? 'auto' : 'smooth' });
    segna();
  }
  var lb = document.querySelector('[data-lb]'), BIG = window.AG_BIG || [], lbi = 0;
  function lbVai(i) {
    if (!lb || !BIG.length) return;
    lbi = (i + BIG.length) % BIG.length;
    var im = track ? track.querySelectorAll('img')[lbi] : null;
    lb.querySelector('[data-lb-img]').src = BIG[lbi];
    lb.querySelector('[data-lb-img]').alt = im ? im.alt : '';
    lb.querySelector('[data-lb-n]').textContent = (lbi + 1) + ' / ' + BIG.length;
  }
  function lbApri(i) { if (!lb) return; lbVai(i); lb.hidden = false; lb.querySelector('[data-lb-x]').focus(); }
  function lbChiudi() { if (!lb) return; lb.hidden = true; vai(lbi, false); }
  if (lb) {
    lb.querySelector('[data-lb-x]').addEventListener('click', lbChiudi);
    lb.querySelector('[data-lb-prev]').addEventListener('click', function () { lbVai(lbi - 1); });
    lb.querySelector('[data-lb-next]').addEventListener('click', function () { lbVai(lbi + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lbChiudi(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') lbChiudi();
      if (e.key === 'ArrowLeft') lbVai(lbi - 1);
      if (e.key === 'ArrowRight') lbVai(lbi + 1);
    });
  }
  if (g && track) {
    track.querySelectorAll('img').forEach(function (im, k) { im.addEventListener('click', function () { lbApri(k); }); });
    var z = g.querySelector('[data-zoom]'); if (z) z.addEventListener('click', function () { lbApri(cur); });
    var pv = g.querySelector('[data-prev]'), nx = g.querySelector('[data-next]');
    if (pv) pv.addEventListener('click', function () { vai(cur - 1); });
    if (nx) nx.addEventListener('click', function () { vai(cur + 1); });
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { vai(k); }); });
    var tmr;
    track.addEventListener('scroll', function () {
      clearTimeout(tmr);
      tmr = setTimeout(function () { var k = Math.round(track.scrollLeft / track.clientWidth); if (k !== cur) { cur = k; segna(); } }, 80);
    });
    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { vai(cur - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { vai(cur + 1); e.preventDefault(); }
    });
    segna();
  }

  /* ---------- varianti ---------- */
  if (!V.length) return;
  var btns = [].slice.call(document.querySelectorAll('[data-ag-opt]'));
  var st = (D.sel || V[0].o).slice();
  function trova(vals) {
    for (var i = 0; i < V.length; i++) {
      var ok = true;
      for (var k = 0; k < vals.length; k++) if (V[i].o[k] !== vals[k]) { ok = false; break; }
      if (ok) return V[i];
    }
    return null;
  }
  var form = document.getElementById('ag-form');
  var idI = form && form.querySelector('[data-ag-id]'), add = form && form.querySelector('[data-ag-add]');
  var tab = document.querySelector('[data-agd-misure]');
  function aggiorna(cambioImg) {
    var v = trova(st);
    if (!v) { for (var i = 0; i < V.length; i++) if (V[i].o[D.last] === st[D.last]) { v = V[i]; break; } }
    if (!v) v = V[0];
    st = v.o.slice();
    btns.forEach(function (b) {
      var k = +b.dataset.agOpt, val = b.dataset.agVal;
      var on = st[k] === val;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      var alt = st.slice(); alt[k] = val;
      var w = trova(alt);
      b.classList.toggle('is-na', !w);
      var pe = b.querySelector('[data-p]');
      if (pe) pe.textContent = w ? eur(w.p) : 'Non disponibile';
    });
    document.querySelectorAll('[data-ag-lab]').forEach(function (l) { l.textContent = st[+l.dataset.agLab]; });
    var q = function (s) { return document.querySelector(s); };
    if (q('[data-prezzo]')) q('[data-prezzo]').textContent = eur2(v.p);
    if (q('[data-sku]')) q('[data-sku]').textContent = v.s || '';
    if (idI) idI.value = v.id;
    if (add) { add.disabled = !v.a; add.textContent = v.a ? 'Aggiungi al carrello' : 'Non disponibile'; }
    if (tab && D.si >= 0) {
      var col = -1;
      tab.querySelectorAll('thead th[data-col]').forEach(function (th) { if (th.textContent.trim() === st[D.si]) col = th.dataset.col; });
      tab.querySelectorAll('[data-col]').forEach(function (c) { c.classList.toggle('is-col', c.dataset.col === String(col)); c.classList.remove('is-cod'); });
      tab.querySelectorAll('tbody tr').forEach(function (tr) {
        var ok = false;
        if (tr.hasAttribute('data-ag-all')) ok = true;
        else if (tr.dataset.agO != null) {
          var os = tr.dataset.agO.split(','), vs = (tr.dataset.agV || '').split('|'); ok = true;
          for (var j = 0; j < os.length; j++) if (st[+os[j]] !== vs[j]) ok = false;
        } else if (D.ci >= 0 && tr.dataset.colore != null) ok = tr.dataset.colore === st[D.ci];
        if (ok) { var c = tr.querySelector('td[data-col="' + col + '"]'); if (c) c.classList.add('is-cod'); }
      });
    }
    if (cambioImg && v.g >= 0) vai(v.g);
    try { if (window.history && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } } catch (e) {}
  }
  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var k = +b.dataset.agOpt; st[k] = b.dataset.agVal; D.last = k;
      aggiorna(k === D.ci || D.ci < 0);
    });
  });
  if (tab) tab.querySelectorAll('.agD-colbtn').forEach(function (b) {
    b.addEventListener('click', function () { if (D.si >= 0) { st[D.si] = b.dataset.misura; D.last = D.si; aggiorna(false); } });
  });
  if (form) {
    var qI = form.querySelector('[data-ag-qty]'), qN = form.querySelector('[data-ag-qn]');
    var m = form.querySelector('[data-ag-meno]'), p = form.querySelector('[data-ag-piu]');
    if (m) m.addEventListener('click', function () { var x = Math.max(1, (+qI.value || 1) - 1); qI.value = x; qN.textContent = x; });
    if (p) p.addEventListener('click', function () { var x = (+qI.value || 1) + 1; qI.value = x; qN.textContent = x; });
  }
  /* misure sotto i bottoni, lette dalla riga "Dimensioni guscio" della scheda tecnica */
  if (tab) {
    var rd = null;
    tab.querySelectorAll('tbody tr').forEach(function (tr) { var t = tr.querySelector('th'); if (!rd && t && /^(Dimensioni|Misure|Diametro|Lunghezza|Capacità)/i.test(t.textContent.trim())) rd = tr; });
    if (rd) {
      var hs = {}; tab.querySelectorAll('thead th[data-col]').forEach(function (th) { hs[th.textContent.trim()] = th.dataset.col; });
      document.querySelectorAll('.agV-t[data-misura]').forEach(function (b) {
        if (b.querySelector('.agV-dim')) return;
        var k = hs[b.dataset.misura], td = k != null && rd.querySelector('td[data-col="' + k + '"]');
        if (td && /\d/.test(td.textContent)) { var sp = document.createElement('span'); sp.className = 'agV-dim'; sp.textContent = td.textContent.trim(); b.insertBefore(sp, b.querySelector('[data-p]')); }
      });
    }
  }
  D.last = 0;
  aggiorna(false);
})();
